module.exports = __webpack_public_path__ + "img/donante-areas.0895bf37.png";